import React from "react";
import "./EcoVision.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";

class EcoVision extends React.Component{
    render() {
        return (
            <div>
                <Nav/>
 <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Project">01 Master Plan</a></p>
              <p className="ab">Planning Structure</p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/PlanningFeatures">Planning Features</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Intro"> 02 Project Introduction</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/ProLoc">04 Project Location</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoVision">05 Eco-Vision</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
            </div>
          </div>
        <div className="col-8">
        <div class="abhead7">
        <p></p>
        </div>
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>Eco-Vision</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}>At the Heart of the Global Circular Economy</p>
        <p className="text-justify">The Good Morning Bamboo Eco-City is not just about being green. It is about creating a vibrant economy, building a home for its residents and fulfilling our collective desires for a better life in harmony with the environment.<br/><br/>Eco-City is more than just about deploying cutting edge technologies or having iconic buildings. It is about practical and well tested solutions. It is about the city’s spirit, civic values and community development, creating a sustainable lifestyle without compromising the residents’ daily needs. Twenty six key performance indicators will be applied to ensure the Eco-City’s sustainable development.

</p>
    <p style={{fontWeight: 'bold'}} className="text-center">26 KEY PERFORMANCE INDICATORS</p>
    <p className="text-center">To measure our success</p>
    <div className="ml-5">
    <img  src="https://i.imgur.com/lLX5QZ7.png" alt="..."/>
        </div>
       </div>
      
     </div>
   </div>
            </div>
        )
    }
}
export default withRouter(EcoVision);